import { colors } from '@alixpartners/ui-components';

export const TABLE_DIMENSIONS = [
	{
		label: 'Show GL',
		value: 2,
	},
	{
		label: 'Show Cost Centres',
		value: 1,
	},
];

export const CHART_COLORS = {
	GREY: colors.grey3,
	GREEN: colors.chartDarkGreen,
	RED: colors.red1,
	AMBER: colors.amber,
};

export const getApiParamsFromFilterModel = filterModel => {
	const filtersObj = filterModel.filters
		? Object.keys(filterModel.filters).reduce(
				(acc, filterName) => {
					return {
						filters: [
							...acc.filters,
							...Array(filterModel.filters[filterName].length).fill(filterName),
						],
						filterValues: [
							...acc.filterValues,
							...filterModel.filters[filterName],
						],
					};
				},
				{ filters: [], filterValues: [] }
		  )
		: {};

	return {
		primaryFilter: filterModel.primaryFilter,
		...filtersObj,
	};
};
